import { query } from "@/utils/api-utils"
import { request } from "."

export const feedbackApi = {
  getPolls() {
    return request("/api/fb/polls")
  },
  createPoll() {
    return request("/api/fb/polls", {})
  },
  getFeedbackData(programId: string, getAll?: boolean) {
    return request("/api/fb/stats?"+query({ programId, getAll }))
  },

  getFeedbackForm() {
    return request("/api/fb/form")
  },
  getBaseInfo(formId: string) {
    return request("/api/fb/"+formId)
  },
  sendForm(pollId: string, values: any) {
    return request("/api/fb/"+pollId, values)
  }
}